import { render, staticRenderFns } from "./EditAddressComponent.vue?vue&type=template&id=94fe789e"
import script from "./EditAddressComponent.vue?vue&type=script&lang=ts"
export * from "./EditAddressComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports